// Kolter Custom JS

// Nav + Header Hintergrund + Link-Farbe: transparent oben, weiss nach Scrollen
(function() {
  var mainNav = document.getElementById('main-nav');
  var isHomepage = document.body.classList.contains('template-index');
  var sectionHeader = document.querySelector('.section-header');

  function setTransparent() {
    if (mainNav) mainNav.style.background = 'transparent';
    if (sectionHeader) sectionHeader.style.background = 'transparent';
    document.querySelectorAll('#main-nav .kolter-tier-1 .navigation__link').forEach(function(l) {
      l.style.color = '#ffffff';
    });
  }

  function setSolid() {
    if (mainNav) mainNav.style.background = '#FDFCF9';
    if (sectionHeader) sectionHeader.style.background = '#FDFCF9';
    document.querySelectorAll('#main-nav .kolter-tier-1 .navigation__link').forEach(function(l) {
      l.style.color = '#7A7570';
    });
  }

  function updateNavBg() {
  if (window.scrollY > 10 || !isHomepage) {
    setSolid();
  } else {
    setTransparent();
  }
 }

  window.addEventListener('scroll', updateNavBg, { passive: true });

  // Hover: Links werden tinte wenn Dropdown offen
  document.addEventListener('DOMContentLoaded', function() {
    var tier1 = document.querySelector('#main-nav .navigation__tier-1');
    if (tier1) {
      tier1.addEventListener('mouseenter', function() {
        setSolid();
      });
      tier1.addEventListener('mouseleave', function() {
    if (window.scrollY <= 10 && isHomepage) {
          setTransparent();
        }
      });
    }
  });

  updateNavBg();
})();

// MegaPanel DOM Teleport
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var mainNav = document.getElementById('main-nav');
    if (!mainNav) return;

    var panels = document.querySelectorAll('#main-nav .kolter-mega-panel');
    panels.forEach(function(panel) {
      var parentItem = panel.closest('.navigation__item');
      mainNav.appendChild(panel);

      panel.style.cssText = 'position:absolute;left:0;right:0;width:100%;top:100%;z-index:9999;visibility:hidden;opacity:0;transition:opacity 0.2s ease,visibility 0s linear 0.2s';

      if (parentItem) {
        parentItem.addEventListener('mouseenter', function() {
          document.querySelectorAll('#main-nav .kolter-mega-panel').forEach(function(p) {
            p.style.visibility = 'hidden';
            p.style.opacity = '0';
          });
          panel.style.visibility = 'visible';
          panel.style.opacity = '1';
          panel.style.transition = 'opacity 0.2s ease';
        });

        parentItem.addEventListener('mouseleave', function() {
          panel.style.visibility = 'hidden';
          panel.style.opacity = '0';
          panel.style.transition = 'opacity 0.2s ease, visibility 0s linear 0.2s';
        });

        panel.addEventListener('mouseenter', function() {
          panel.style.visibility = 'visible';
          panel.style.opacity = '1';
        });

        panel.addEventListener('mouseleave', function() {
          panel.style.visibility = 'hidden';
          panel.style.opacity = '0';
          panel.style.transition = 'opacity 0.2s ease, visibility 0s linear 0.2s';
        });
      }
    });
  });
})();

// Kolter: Reset Hover-Bild nach Mouse-Leave
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-block').forEach(function(block) {
    block.addEventListener('mouseleave', function() {
      var primaryImg = block.querySelector('.product-block__image--primary');
      var allImgs = block.querySelectorAll('.product-block__image');
      allImgs.forEach(function(img) {
        img.classList.remove('product-block__image--active');
      });
      if (primaryImg) {
        primaryImg.classList.add('product-block__image--active');
      }
    });
  });
});
